import Faqs from "./Faqs";
export {Faqs};